import React from 'react';
import classNames from 'classnames';
import { toast } from 'react-toastify';

import { Button, Modal } from '../../../components/general';

import { PublicEvent } from '../../../types';
import { getHashTagText } from '../../../utils';

interface Props {
  show: boolean;
  onHide: () => void;
  event: PublicEvent | null;
  handleNativeShare: (type: string, newFile?: File) => void;
  isCaptionOnly: boolean;
  isPreview: boolean;
  width: number;
}

const CaptionModal: React.FC<Props> = (props) => {
  const {
    show,
    onHide,
    event,
    handleNativeShare,
    isCaptionOnly,
    isPreview,
    width,
  } = props;

  if (!event) return null;

  const { caption } = event;
  const hashTag = ['crowdclip', ...(event.hashTag ?? [])];

  // copy text to clipboard
  const handleCopy = (copyText: string) => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        toast.success('Copied to clipboard!', { toastId: 'copy-success' });
      })
      .catch((error) => {
        console.error('Failed to copy:', error);
      });
  };

  // text that user will copy
  const copyText = caption + '\n\n' + getHashTagText(hashTag);

  return (
    <Modal
      id="caption-modal"
      show={show}
      onHide={onHide}
      size="lg"
      isPreview={isPreview}
    >
      <Modal.Body className="text-center">
        <h4 className="m-0">Use pre-generated caption?</h4>

        <div>
          No need to get stuck on what to write. Simply use the generated
          hashtags and caption below to make your post stand out.
        </div>

        <div
          id="video-caption-field"
          className={classNames(
            'w-full h-32 flex flex-col px-3 py-1.5 items-start text-left text-sm bg-grey-100 whitespace-pre-wrap overflow-x-auto overflow-y-scroll rounded-md border border-grey-200 border-solid',
            { 'sm:h-20': !isPreview },
          )}
        >
          <div>{caption}</div>

          <div>
            {hashTag.map((ht, index) => (
              <React.Fragment key={index}>
                <a
                  href={`https://www.instagram.com/explore/tags/${ht}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  #{ht}
                </a>{' '}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div
          className={classNames('flex flex-col gap-4', {
            'sm:flex-row': !isPreview,
          })}
        >
          <Button
            className={classNames('w-full', { 'sm:w-1/2': !isPreview })}
            onClick={() => {
              handleCopy(copyText);
              onHide();

              if (!isCaptionOnly) handleNativeShare('With caption');
            }}
          >
            Yes, Copy Caption to Clipboard
          </Button>

          <Button
            colour="pink"
            className={classNames('w-full', { 'sm:w-1/2': !isPreview })}
            onClick={() => {
              onHide();

              if (!isCaptionOnly) handleNativeShare('Without caption');
            }}
          >
            No{!isCaptionOnly && ', Continue Without Caption'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CaptionModal;
